import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import '../../css/Shared/Header.css';
import { connect } from 'react-redux';
import dropdownarrow from '../../Assets/Announcement/Assets-Desktop/down_arrow.svg';
import notification from '../../Assets/Announcement/Assets-Desktop/notif.svg';
import menu from '../../Assets/Announcement/Assets-Desktop/user.svg';
import drawer from '../../Assets/Announcement/Assets-Tablet/menu.svg';
import page4 from '../../Assets/Announcement/images/arrow-right.svg';
import closeicon from '../../Assets/CustomerSupport/Assets-WebApp/close-icon.svg';
import condense from '../../Assets/CustomerSupport/Assets-WebApp/condense.svg';
import customerServicewhite from '../../Assets/CustomerSupport/Assets-WebApp/customerService-white.svg';
import expand from '../../Assets/CustomerSupport/Assets-WebApp/expand.svg';
import ProfileModal from '../Shared/ManageProfileModal';
import premiumIcon from '../../Assets/ContainerStatus/Assets_Desktop/premium.svg';
import withoutNotification from '../../Assets/ProfileManagement/Assets-Desktop/withoutNotification.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import SideNav from '../Shared/SideNav';
import AcceptTermsConditionsModal from '../Shared/AcceptTermsConditionsModal';
import TermsConditionModal from '../Shared/TermsConditionModal';
import { Link } from 'react-router-dom';
// for redux
import { useDispatch, useSelector } from 'react-redux';
import { ApiCall } from '../../Services/utils/ApiCall';
import { baseURL, utilityBaseURL } from '../../Services/config/apiGateway';
import {
  TERMS_AND_CONDITIONS_ENDPOINT, ACCEPT_TERMS_AND_CONDITIONS_ENDPOINT, DOCUMENT_ENDPOINT, USER_PROFILE_DETAILS
  , DISABLE_NOTIFICATION_FLAG
} from '../../Services/config/apiEndPoints';
import { successLoader, } from '../../Redux/_actions/loader.action';
import { store } from '../../Redux/_helpers/store';
import { successUserProfileInfo } from '../../Redux/_actions/userProfileInfo.action';
import { AES, enc } from 'crypto-js';
import Cookies from 'cookies-js';
import Logout from '../../Services/utils/Logout';
import {release} from '../../Services/utils/appMode';
let selectedProfileIndex;

function Header(props) {
  const dispatch = useDispatch();
 
  const userProfileDataR = props.userProfileDataRFun;
 // const userProfileDataR = useSelector(state => state.userProfileInfoReducer.data);
  const manageProfileDataR = useSelector(state => state.manageProfileReducer.data);
  const loginDataR = props.loginDataRFun;
  //useSelector(state => JSON.parse(AES.decrypt(state.authentication.user, 'TPT_CARGO_CONNECT').toString(enc.Utf8)));
  const location = useLocation();
  let history = useHistory();
  const [dropdown, setdropdown] = useState(false);
  const [hasOpen, setHasOpen] = useState(false);
  const container = React.createRef();
  const [bellicon, setBellicon] = useState(false);
  const [openSidenav, setOpenSidenav] = useState(false);
  const mobileNumber = location.mobileNumber;
  const [hashOPenValue, setHashOPenValue] = useState(false);
  const [CustomerService, setCustomerService] = useState(false);
  const [hasOpenterms, sethasOpenterms] = useState(false);
  const [hasOpentermsCondition, sethasOpentermsCondition] = useState(true);
  const pdfURL = utilityBaseURL + DOCUMENT_ENDPOINT + "?documentPath=";
  const toggleDropdown = () => {
    setdropdown(!dropdown);
  }
  useEffect(() => {
     
    // if(userProfileDataRValidate){
    // userProfileDataR =  useSelector(state => JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8)));
    // }
    document.addEventListener("mousedown", handleClickOutside);
    var userEmailValue;
    if(loginDataR){
      userEmailValue = loginDataR?.userDetails?.userdetails?.user?.userEmail
    }else if(userProfileDataR){
      userEmailValue = userProfileDataR?.userEmail
    }
    ApiCall(
      'GET',
      baseURL + USER_PROFILE_DETAILS + `?userName=${userEmailValue}`,
      {},
      {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      false
    ).then(data => {
      if (data.flag != -1) {
        if (data.flag == 500) {
          console.log("I am 500")
        }
        else {
          console.log('I am 200!');
          const encryptedDataUserProfile = AES.encrypt(JSON.stringify(data), 'TPT_CARGO_CONNECT').toString();
          dispatch(successUserProfileInfo(encryptedDataUserProfile));
          props.tilesFetched(true);
          // for terms and condition set flag value
          sethasOpentermsCondition(data.active);
          console.log("notification flag all data", data);
          setBellicon(data.notificationFlag);
        }
      }
    });
  }, []);
  
  const handleClickOutside = event => {
    if (container.current && !container.current.contains(event.target)) {
      setdropdown(false);
    }
  };
  const profileCheck = (event) => {
    history.push('/profileActivity');
  }
  const HelloUser = (event) => {
    history.push({
      pathname: '/helloUser',
      mobileNumber: mobileNumber,
    });
  }
  const onCloseModal = () => {
    setHasOpen(false);
  };
  const handelUser = () => {
    setHashOPenValue(true);
    setHasOpen(true);
  };
  
  const setModalCloseFlag = (flagValue) => {
    setHashOPenValue(flagValue);
  }
  const onPremimum = () => {
    history.push('/ManageSubscription');
  }
  const onAddProfile = () => {
    history.push('/addProfile');
  };
  const handleNotification = () => {
    ApiCall(
      'PUT',
      utilityBaseURL + DISABLE_NOTIFICATION_FLAG,
      {},
      {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        "userId": userProfileDataR?.userId,
      },
    ).then(data => {
      if (data.flag != -1) {
        if (data.flag == 500) {
          console.log("I am 500")
        }
        else {
          console.log('I am 200!');
        }
      }
    })
    history.push('/notification');
  }
  const showCustomerService = () => {
    setCustomerService(!CustomerService);
  }
  const handleRaiseQuery = () => {
    history.push('/RaiseQuery');
  }
  const handleContactUs = () => {
    history.push('/ContactUs');
  }
  const handleFAQ = () => {
    history.push('/FAQ');
  }
  const handleTermsConditions = () => {
    setdropdown(false);
    openTermsConditons();
  }
  const openTermsConditons = () => {
    ApiCall(
      'GET',
      baseURL + TERMS_AND_CONDITIONS_ENDPOINT,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    ).then((apiData) => {
      if (apiData.flag != -1) {
        if (apiData.flag == 500) {
          console.log("I am 500");
        }
        else {
          console.log('I am 200!');
          console.log("terms and conditions", apiData);
          const testAccess = Cookies.get('_msAL');
          //start
          dispatch(successLoader(false));
          var oReq = new XMLHttpRequest();
          var URLToPDF = pdfURL + apiData[0].termsFile;
          oReq.open("GET", URLToPDF, true);
          oReq.setRequestHeader("Authorization", 'Bearer' + ` ${testAccess}`);
          oReq.responseType = "blob";
          oReq.onload = function () {
            // Once the file is downloaded, open a new window with the PDF
            // Remember to allow the POP-UPS in your browser
            const file = new Blob([oReq.response], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            //end
            dispatch(successLoader(true));
            window.open(fileURL, "_blank");
          };
          oReq.send();
        }
      }
    });
  }
  const handleLogout = () => {
    Logout();
  }



  // accept TnC
  const onCloseTermsConditionModal = () => {
    ApiCall(
      'PUT',
      baseURL + ACCEPT_TERMS_AND_CONDITIONS_ENDPOINT,
      {
        "tncVersion": "1.0",
        "tncConform": true,
        "userEmail":  userProfileDataR?.userEmail
      },
      {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    ).then(data => {
      if (data.flag != -1) {
        if (data.flag == 500) {
          console.log("I am 500");
          console.log("tnc response data", data);
        }
        else {
          console.log('I am 200!');
          console.log("tnc response data", data);
          sethasOpentermsCondition(true);
        }
      }
    })
  };
  const onYesModal = () => {
    sethasOpentermsCondition(false);
  };
  const onClosetermsModal = () => {
    sethasOpenterms(false);
  };
  const showTermsAndCondition = () => {
    openTermsConditons();
  }
  return (
    <>
      <header>
        <nav className="navbar navbar-white bg-white " id="header">
          <div className="drawericon">
            <img src={drawer} onClick={() => { return setOpenSidenav(true); }} id="drawer" width="26" height="20" class=" pt-1" alt="" loading="eager" />
            {openSidenav ? <div className="sidenavouter"><SideNav onClick={() => setOpenSidenav(false)} /></div> : null}
          </div>
          <Link to="/home"> <div className="headerlogo"></div></Link>
          <div>
            <div class="pr-3" style={{ display: '-webkit-box' }} >
              <div class="pt-1 pl-1" id="group1">
                <div class="cargoConnect"
                
                onClick={  release === '2' ? handelUser : null } 
                 >
                  <small class="" id="cc" >Cargo Connect  </small>
                  { release === '2' &&
                  <img src={dropdownarrow} width="10" height="8" class=" pt-0" alt="" loading="eager" />
  }
                </div>
                <div class="headerpreview">
                  <small id="preview" >{userProfileDataR?.userType === "Preview" ? manageProfileDataR?.selectedProfileType : (userProfileDataR?.userType === "Premium" ? manageProfileDataR?.selectedProfileType : '')}</small></div>
              </div>
              <img src={bellicon ? notification : withoutNotification} onClick={handleNotification} id="notification" width="22" height="26" class=" pt-1" alt="" loading="eager" />
              <img src={menu} id="menu" onClick={HelloUser} width="25" height="25" class=" pt-1" alt="" loading="eager" />
              <img src={dropdown ? closeicon : drawer} id="headernavdrawer" onClick={toggleDropdown} width="22" height="22" class=" pt-1" alt="" loading="eager" />
            </div>
            {dropdown && (
              <div id="headerdropdown" ref={container} >
                <img src={dropdownarrow} id="dropdownArrow" width="11" height="9" class=" pt-0" alt="" loading="eager" />
                {release === '2' &&
                <div class="newdroppremiumdiv">
                  <div class="newdroppremiumdivin" onClick={onPremimum}>
                    <div class="newdroppremiumdivleftp">
                      <img src={premiumIcon} id="" width="25" height="25" class="d-inline-block pt-1" alt="" loading="eager" />
                    </div>
                    <div class="newdroppremiumdivright">
                      <small class="newdroppremiumdivsm">Premium</small>
                      <img src={page4} id="newsidearrowimg" class="d-inline-block" alt="" loading="eager" />
                    </div>
                  </div>
                </div>
            }
                <div class="newdropcustomersupdivouter">
                  <div class="newdropcustomersupdiv">
                    <div class="newdropcustomersupdivin" onClick={showCustomerService}>
                      <div class="newdroppremiumdivleftp">
                        <img src={customerServicewhite} id="" width="25" height="25" class="d-inline-block pt-1" alt="" loading="eager" />
                      </div>
                      <div class="newdroppremiumdivright">
                        <small class="newdroppremiumdivsm">Customer Service</small>
                        <img src={CustomerService ? condense : expand} id="newsideexpandimg" class="d-inline-block" alt="" loading="eager" />
                      </div>
                    </div>
                  </div>
                  {CustomerService &&
                    <div class="newdropcustomersupdivoption">
                      <div class="newdroppremiumdivinoption">
                        <div class="newdroppremiumdivleft">
                        </div>
                        <div class="newdroppremiumdivright" onClick={handleFAQ}>
                          <small class="newdroppremiumdivsm">FAQ</small>
                          <img src={page4} id="newsidearrowimg" class="d-inline-block" alt="" loading="eager" />
                        </div>
                      </div>
                      <div class="newdroppremiumdivinoption">
                        <div class="newdroppremiumdivleft">
                        </div>
                        <div class="newdroppremiumdivright" onClick={handleRaiseQuery}>
                          <small class="newdroppremiumdivsm">Raise Query</small>
                          <img src={page4} id="newsidearrowimg" class="d-inline-block" alt="" loading="eager" />
                        </div>
                      </div>
                      <div class="newdroppremiumdivinoption">
                        <div class="newdroppremiumdivleft">
                        </div>
                        <div class="newdroppremiumdivright" onClick={handleContactUs}>
                          <small class="newdroppremiumdivsm">Contact Us</small>
                          <img src={page4} id="newsidearrowimg" class="d-inline-block" alt="" loading="eager" />
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div class="newdroptandcdiv">
                  <div class="newdroptandcdivin" onClick={handleTermsConditions}>
                    <small class="newdroppremiumdivsm">Terms and Conditions</small>
                  </div>
                </div>
                <div class="newdroptandcdiv">
                  <div class="newdroptandcdivin" onClick={handleLogout}>
                    <small class="newdroppremiumdivsm">Logout</small>
                  </div>
                </div>
              </div>
            )}
          </div>
          {hashOPenValue &&
            <ProfileModal hasOpen={hasOpen} onCloseModal={onCloseModal} AddProfile={onAddProfile}
              profileCheck={profileCheck}
              setModalCloseFlag={setModalCloseFlag}
            />
          }
          <AcceptTermsConditionsModal hasOpen={!hasOpentermsCondition} onCloseModal={onCloseTermsConditionModal} onYesModal={onYesModal}>
            <div>
              <div class="AccepttermscondiDivout">
                <small class="AccepttermscondiDivsm">Terms & Conditions Updated</small>
                <small class="AccepttermscondiDivsmb"> Last Updated 19-Feb-2021</small>
                <div class="AccepttermscondiDivin">
                  <small class="AccepttermscondiDivinsm">Please read and accept the new</small>
                  <small class="AccepttermscondiDivinsmb" onClick={showTermsAndCondition}>
                    <small class="AccepttermscondiDivinsmtc">Terms & Conditions </small>
                                to proceed.
                                </small>
                </div>
              </div>
            </div>
          </AcceptTermsConditionsModal>
          {hasOpenterms ? <TermsConditionModal onClick={onClosetermsModal} /> : null}
        </nav>
      </header>
    </>
  );
}
function mapStateToProps(state) {
  if (state.userProfileInfoReducer.data) {
    return {
 //  loginDataRFun :  JSON.parse(AES.decrypt(state.authentication.user, 'TPT_CARGO_CONNECT').toString(enc.Utf8)),
    userProfileDataRFun : JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8)),
      
    }
  }
  if(state.authentication.user){
    return {
      loginDataRFun :  JSON.parse(AES.decrypt(state.authentication.user, 'TPT_CARGO_CONNECT').toString(enc.Utf8)),
    }
  }
}
export default connect(mapStateToProps)(Header);
